import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import apiMethod from "../../../services/api-service";
import methods from "../../../services/utility";
import Preloading from "../../../components/basics/Preloading";
import { toast } from "react-toastify";

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import DeleteModal from "../../../components/deleteModal/DeleteModal";

const CallCenter = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formModel, setFormModel] = useState({
    id: 0,
    branchId: branchId,
    dataList: [
      {
        phoneNumber: "",
        line: 0,
        extentions: [],
      },
    ],
  });
  const [showFormModal, setShowFormModal] = useState(false);
  const [newExtention, setNewExtention] = useState("");
  const [editIndex, setEditIndex] = useState(-1);

  const getGridData = async () => {
    const resp = await apiMethod.getCallCenterInfo(branchId);
    if (methods.showApiErrors(resp)) {
      setGridData(resp.data.dataList || []);
      setFormModel((prev) => ({
        ...prev,
        id: resp.data.id,
      }));
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    };
    bindData();
  }, [branchId]);

  const saveCallcenter = async (data) => {
    const resp = await apiMethod.createCallCenterInfo(data);
    if (methods.showApiErrors(resp)) return true;
    return false;
  };

  const editItem = (item, index) => {
    setEditIndex(index);
    setNewExtention("");
    setFormModel((prev) => ({
      id: prev.id,
      branchId: prev.branchId,
      dataList: [
        {
          phoneNumber: item.phoneNumber,
          line: item.line,
          extentions: [...item.extentions],
        },
      ],
    }));
    setShowFormModal(true);
  };

  const createNewItem = async () => {
    const currentItem = formModel.dataList[0];

    if (methods.isNullOrEmptyString(currentItem.phoneNumber)) {
      methods.showErrors(["شماره تماس الزامی است."]);
      return false;
    }

    if (
      methods.isNullOrEmptyString(currentItem.line) ||
      currentItem.line === 0
    ) {
      methods.showErrors(["پیش شماره داخلی الزامی است."]);
      return false;
    }

    setLoading(true);
    try {
      const newItem = {
        phoneNumber: currentItem.phoneNumber,
        line: currentItem.line,
        extentions: currentItem.extentions,
      };

      let updatedDataList;
      if (editIndex !== -1) {
        updatedDataList = gridData.map((item, index) =>
          index === editIndex ? newItem : item
        );
      } else {
        updatedDataList = [...gridData, newItem];
      }

      const newobj = {
        id: formModel.id,
        branchId: formModel.branchId,
        dataList: updatedDataList,
      };

      const isOk = await saveCallcenter(newobj);

      if (!isOk) {
        setLoading(false);
        return false;
      }

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const changeInputField = (field, value) => {
    setFormModel((prev) => ({
      ...prev,
      dataList: [
        {
          ...prev.dataList[0],
          [field]: value,
        },
      ],
    }));
  };

  const addExtention = () => {
    if (methods.isNullOrEmptyString(newExtention)) {
      methods.showErrors(["داخلی باید مقدار داشته باشد"]);
      return false;
    }

    const trimmedExt = newExtention.trim();
    if (trimmedExt === "") return;

    if (formModel.dataList[0].extentions.includes(trimmedExt)) {
      methods.showErrors(["این شماره داخلی قبلاً اضافه شده است."]);
      return false;
    }

    setFormModel((prev) => ({
      ...prev,
      dataList: [
        {
          ...prev.dataList[0],
          extentions: [...prev.dataList[0].extentions, trimmedExt],
        },
      ],
    }));
    setNewExtention("");
  };

  const removeExtention = (extIndex) => {
    setFormModel((prev) => ({
      ...prev,
      dataList: [
        {
          ...prev.dataList[0],
          extentions: prev.dataList[0].extentions.filter(
            (_, index) => index !== extIndex
          ),
        },
      ],
    }));
  };

  const openNewForm = () => {
    resetForm();
    setShowFormModal(true);
  };

  const resetForm = () => {
    setFormModel((prev) => ({
      id: prev.id,
      branchId: prev.branchId,
      dataList: [
        {
          phoneNumber: "",
          line: 0,
          extentions: [],
        },
      ],
    }));
    setNewExtention("");
    setEditIndex(-1);
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDelelteModal = () => {
    setShowDeleteModal(false);
  };

  const selectItemToDelete = (item, index) => {
    setSelectedId(index);
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    if (selectedId === null) return;

    setLoading(true);
    try {
      const updatedDataList = gridData.filter(
        (_, index) => index !== selectedId
      );

      const newobj = {
        id: formModel.id,
        branchId: formModel.branchId,
        dataList: updatedDataList,
      };

      const isOk = await saveCallcenter(newobj);

      if (!isOk) {
        setLoading(false);
        return false;
      }

      await getGridData();
      setShowDeleteModal(false);
      setSelectedId(null);
    } catch (error) {
      console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  console.log({ "gridData:::": gridData });

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        <div className="d-none d-lg-block">
          <Link
            to={`/sale/${branchId}/#5`}
            className="text-start mb-3 link back-link"
          >
            <span>
              <img src={back} className="" alt="return" />
            </span>
            بازگشت
          </Link>
        </div>
        <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
          <div>
            <Link to={`/sale/${branchId}/#5`} className="link back-link">
              <span>
                <img src={back} className="" alt="return" />
              </span>
            </Link>
            تنظیمات مرکز تماس
          </div>
          <p className="date">{methods.currentDate()}</p>
        </div>
        <div className="saleheader d-none d-lg-block">
          <p>تنظیمات مرکز تماس</p>
        </div>
        <div className="salemain">
          <div className="salesearchsection">
            <div className="row g-1">
              <div className="col-12 col-md-6 col-lg-4"></div>
              <div className="col-12 col-md-2 col-lg-4"></div>
              <div className="col-12 col-md-4">
                <div className="createButton">
                  <button
                    onClick={openNewForm}
                    className="btn btn-outline-purple custome-btn"
                    type="button"
                  >
                    <span className="align-middle d-inline-block">
                      شماره جدید
                    </span>{" "}
                    <i className="bi bi-plus-circle align-middle"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="table-responsive saletable">
            <table className="table table-striped table-md align-middle">
              <thead className="">
                <tr>
                  <th scope="col vertical-center" width="20px">
                    ردیف
                  </th>
                  <th scope="col vertical-center">شماره تماس</th>
                  <th scope="col vertical-center">خط</th>
                  <th scope="col vertical-center">داخلی‌ها</th>
                  <th scope="col vertical-center" width="100px">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {gridData.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.phoneNumber}</td>
                    <td>{item.line}</td>
                    <td>
                      {item.extentions.length > 0
                        ? item.extentions.join(", ")
                        : "-"}
                    </td>
                    <td>
                      <button
                        onClick={() => editItem(item, index)}
                        className="btn btn-sm btn-outline-purple me-2"
                        type="button"
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                      <button
                        onClick={() => selectItemToDelete(item, index)}
                        className="btn btn-sm btn-outline-danger"
                        type="button"
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  const Modal = () => {
    const currentItem = formModel.dataList[0];

    return (
      <div
        className="modal fade show"
        tabIndex="-1"
        role="dialog"
        style={{ display: showFormModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-md" role="document">
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش تلفن</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label
                    htmlFor="phoneNumber"
                    className="form-label required-label"
                  >
                    شماره
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phoneNumber"
                    value={currentItem.phoneNumber}
                    onChange={(e) =>
                      changeInputField("phoneNumber", e.target.value)
                    }
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="line" className="form-label required-label">
                    پیش شماره داخلی
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="line"
                    value={currentItem.line}
                    onChange={(e) => changeInputField("line", e.target.value)}
                  />
                </div>
                <div className="col-md-12">
                  <label
                    htmlFor="extentions"
                    className="form-label required-label"
                  >
                    شماره های داخلی
                  </label>
                  <div className="d-flex">
                    <input
                      type="text"
                      className="form-control"
                      value={newExtention}
                      onChange={(e) => setNewExtention(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          addExtention();
                        }
                      }}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-purple ms-2"
                      onClick={addExtention}
                    >
                      <i className="bi bi-plus-circle"></i>
                    </button>
                  </div>
                  <ul className="list-group my-3">
                    {currentItem.extentions.map((ext, extIndex) => (
                      <li
                        key={extIndex}
                        className="d-flex justify-content-between border p-2 mb-3"
                      >
                        <span>{ext}</span>
                        <i
                          className="btn btn-sm bi bi-trash text-danger ms-2"
                          onClick={() => removeExtention(extIndex)}
                          style={{ cursor: "pointer" }}
                        ></i>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeModal}
              >
                انصراف
              </button>
              <button
                type="submit"
                className="btn custome-btn btn-purple w-50"
                onClick={createNewItem}
              >
                ثبت وذخیره
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDelelteModal}
          deleteItem={deleteItem}
          text={"مرکز تماس"}
        />
      )}
    </>
  );
};

export default CallCenter;
